module.exports = __webpack_public_path__ + "static/d_card_5-83dfe565e1891bab2aac43f14d4f06fa.webp";